module.exports = __webpack_public_path__ + "img/quick.979cc5f4.png";